<template>
  <div class="party-msg">
    <div class="header">
      <p>乡镇/村党员信息统计图</p>
      <p>总党员人数：{{title}}人</p>
    </div>
    <div class="picture">
      <pictures :datas="Data" @change="change"></pictures>
    </div>
    <div class="about-statistics">
      <p>关于统计</p>
      <aboutStatistics :title="aboutTitle"></aboutStatistics>
    </div>
  </div>
</template>
<script>
import pictures from "./module/_picture";
import aboutStatistics from "./module/_statisticsTemplate";
export default {
  data() {
    return {
      title: "",
      Data: [],
      first: [],
      secondMan: [],
      secondWoman: [],
      aboutTitle: []
    };
  },
  components: {
    pictures,
    aboutStatistics
  },
  methods: {
    change(type, name) {
      if (type == "type") {
        if (name == "男党员") {
          this.Data = this.secondMan;
        } else {
          this.Data = this.secondWoman;
        }
      } else this.Data = this.first;
    },
    getMsg() {
      this.axios
        .post("/api/Statistics/Information", {
          c1roleid: sessionStorage.getItem("roleid"),
          c2name: sessionStorage.getItem("token"),
          c2town: sessionStorage.getItem("town")
        })
        .then(e => {
          switch (e.data.code) {
            case 0:
              // 关于统计
              this.aboutTitle.push({
                title: "年龄阶段0-30",
                content: e.data.msg["0-30"]
              });

              this.aboutTitle.push({
                title: "年龄阶段30-40",
                content: e.data.msg["30-40"]
              });

              this.aboutTitle.push({
                title: "年龄阶段40-50",
                content: e.data.msg["40-50"]
              });

              this.aboutTitle.push({
                title: "年龄阶段50-60",
                content: e.data.msg["50-60"]
              });this.aboutTitle.push({
                title: "年龄阶段60-70",
                content: e.data.msg["60-70"]
              });
              this.aboutTitle.push({
                title: "年龄阶段70以上",
                content: e.data.msg["70以上"]
              });

              // 数据
              this.title = e.data.count;
              let remarkTemp = e.data.remark;
              let party = [
                {
                  value: remarkTemp.split("女党员:")[1].split(" ")[0],
                  name: "男党员"
                },
                {
                  value: remarkTemp.split("男党员:")[1].split(" ")[0],
                  name: "女党员"
                }
              ];
              //党员的方法
              this.first = party;
              this.Data = this.first;

              //这是不好的方法,这里是强制让子元素进行渲染

              //第二层内容的数据
              // 女党员
              let arr = remarkTemp.split("男党员")[0].split("女党员");
              let arrs = [];
              arr.filter(item => {
                if (item != "") {
                  // console.log(item.split(' ')[1].split('')[0]);
                  arrs.push(item.split(" ")[1].split("	")[0]);
                }
              });

              arrs.filter(item => {
                this.secondWoman.push({
                  value: item.split(":")[1].split("人")[0],
                  name: item.split(":")[0]
                });
              });
              // 男党员
              let arrMan = remarkTemp
                .split("女党员")
                [remarkTemp.split("女党员").length - 1].split("男党员");
              let arrsMan = [];
              arrMan.filter(item => {
                if (item != "") {
                  // console.log(item.split(' ')[1].split('')[0]);
                  arrsMan.push(item.split(" ")[1].split("	")[0]);
                }
              });

              arrsMan.filter(item => {
                this.secondMan.push({
                  value: item.split(":")[1].split("人")[0],
                  name: item.split(":")[0]
                });
              });
              break;

            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  mounted() {
    this.getMsg();
  }
};
</script>
<style lang='scss' scoped>
.party-msg {
  .about-statistics {
    p {
      line-height: 3;
      padding-left: 0.2rem;
    }
  }
  .picture {
    margin-top: 0.2rem;
  }
  .header {
    p {
      &:nth-child(1) {
        color: #ffa000;
        font-size: 0.32rem;
      }
    }
    text-align: center;
    background: #fff;
    line-height: 2;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>